document.addEventListener('DOMContentLoaded', function () {
    var colourList = document.getElementById('colour-list');
    var collectionList = document.getElementById('collection-list');
    var grid = document.querySelector('.collection__grid');
    var resetBtn = document.getElementById('reset-button');
    var selectedColours = [];
    var selectedNames = [];

    // Save initial grid HTML
    var initialGridHTML = grid.innerHTML;

    function setResetState() {
        if (selectedColours.length === 0 && selectedNames.length === 0) {
            resetBtn.classList.remove('font-weight--bold');
        } else {
            resetBtn.classList.add('font-weight--bold');
        }
    }

    function renderByState() {
        setResetState();
        // If nothing selected, restore initial grid
        if (selectedColours.length === 0 && selectedNames.length === 0) {
            grid.innerHTML = initialGridHTML;
            return;
        }

        // Prefer fetching by the filter type that currently has selections
        if (selectedColours.length > 0 && selectedNames.length === 0) {
            grid.innerHTML = '';
            fetch('/umbraco/surface/Products/GetFilteredResultsByColour?colour=' + selectedColours)
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    if (data != "No results") {
                        buildResults(data, grid);
                    } else {
                        grid.innerHTML = '<p>' + data + '</p>';
                    }
                })
                .catch(function (error) {
                    grid.innerHTML = '<p>Error getting results ' + error + '</p>';
                });
            return;
        }

        if (selectedNames.length > 0 && selectedColours.length === 0) {
            grid.innerHTML = '';
            fetch('/umbraco/surface/Products/GetFilteredResultsByRange?id=' + selectedNames)
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    if (data != "No results") {
                        buildResults(data, grid);
                    } else {
                        grid.innerHTML = '<p>' + data + '</p>';
                    }
                })
                .catch(function (error) {
                    grid.innerHTML = '<p>Error getting results ' + error + '</p>';
                });
            return;
        }

        // If both have selections, default to colour (or choose one consistently)
        grid.innerHTML = '';
        fetch('/umbraco/surface/Products/GetFilteredResultsByColour?colour=' + selectedColours)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                if (data != "No results") {
                    buildResults(data, grid);
                } else {
                    grid.innerHTML = '<p>' + data + '</p>';
                }
            })
            .catch(function (error) {
                grid.innerHTML = '<p>Error getting results ' + error + '</p>';
            });
    }

    colourList.addEventListener('click', function (e) {
        if (e.target.classList.contains('collection__colour')) {
            e.target.classList.toggle('selected');
            var colour = e.target.getAttribute('data-colour');
            if (e.target.classList.contains('selected')) {
                if (!selectedColours.includes(colour)) selectedColours.push(colour);
            } else {
                selectedColours = selectedColours.filter(c => c !== colour);
            }

            e.target.classList.toggle('font-weight--bold');
            renderByState();
        }
    });

    collectionList.addEventListener('click', function (e) {
        if (e.target.classList.contains('collection__name')) {
            e.target.classList.toggle('selected');
            var dId = e.target.getAttribute('data-id');
            if (e.target.classList.contains('selected')) {
                if (!selectedNames.includes(dId)) selectedNames.push(dId);
            }
            else {
                selectedNames = selectedNames.filter(n => n != dId);
            }

            e.target.classList.toggle('font-weight--bold');
            renderByState();
        }
    });

    resetBtn.addEventListener('click', function (e) {
        document.querySelectorAll('.selected').forEach(el => el.classList.remove('selected', 'font-weight--bold'));
        if (resetBtn.classList.contains('font-weight--bold')) {
            resetBtn.classList.remove('font-weight--bold');
        }

        // Restore initial grid HTML
        grid.innerHTML = initialGridHTML;
        selectedColours = [];
        selectedNames = [];
    });
});

function buildResults(data, grid) {
    data.forEach(child => {
        // Update these property names to match your AJAX result
        const imageUrl = child.image || '';
        const name = child.name || '';
        const sku = child.sku || '';
        // Handle both camelCase and PascalCase, depending on serializer
        const swatch = (child.flatSwatchImage || child.FlatSwatchImage || '').trim();
        const shopifyHideId = (child.shopifyHideID || child.ShopifyHideID || '').trim();

        const col = document.createElement('div');
        col.className = 'col products__child relative';
        col.innerHTML = `
            <picture>
            <source srcset="${imageUrl}&format=webp" type="image/webp">
            <img loading="lazy" width="150" height="80" class="products__child-img" src="${imageUrl}" alt="${name}">
            </picture>
            <p id="prod-name" class="font-weight--bold margin--none">${name}</p>
            <p class="margin--none">${sku}</p>
            <div class="products__overlay absolute flex flex--column">
            <button type="button" class="products__child-button products__button--add flex flex--align-center flex--justify-center" data-product-id="${shopifyHideId}" data-product-type="Hide" data-product-name="${name}" data-product-img="${imageUrl}" data-product-price="" data-product-sku="${sku}">
                <i class="icon icon--basket-add"></i>
            </button>
            ${swatch ? `
            <a href="${swatch}" class="products__child-button flex flex--align-center flex--justify-center decoration--none" aria-label="Download swatch" target="_blank" rel="noopener">
                <i class="icon icon--download"></i>
            </a>` : ''}
            </div>
        `;

        grid.appendChild(col);
    });
}
